var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B85B1A68-25E3-4796-A75F-8CC2F25FBC9C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FT1380-&-FT1390-Crimp-Machines---Lomar-header",
    transform: "translate(-471.000000, -1135.000000)",
    stroke: "#E10210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(471.000000, 1135.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(7.310080, 7.548276)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "5.34061817 0 9.79234183 4.45172366 5.34061817 8.90344733"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.27373675e-13,
    y1: 4.45172366,
    x2: 9.79234183,
    y2: 4.45172366,
    id: "Path-4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkarrow);
export default __webpack_public_path__ + "static/media/link arrow.2631d6ac08cc08c788de3e8040d9e4e1.svg";
export { ForwardRef as ReactComponent };